import Icon from '../components/Icon.vue'

Icon.register({
  bus: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 128H480V80C480 35.2 380.8 0 256 0S32 35.2 32 80V128H24C10.8 128 0 138.7 0 152V232C0 245.3 10.8 256 24 256H32V416C32 433.7 46.3 448 64 448V480C64 497.7 78.3 512 96 512H128C145.7 512 160 497.7 160 480V448H352V480C352 497.7 366.3 512 384 512H416C433.7 512 448 497.7 448 480V448H454.4C470.4 448 480 435.2 480 422.4V256H488C501.3 256 512 245.3 512 232V152C512 138.7 501.3 128 488 128zM112 400C94.3 400 80 385.7 80 368S94.3 336 112 336 144 350.3 144 368 129.7 400 112 400zM128 288C110.3 288 96 273.7 96 256V128C96 110.3 110.3 96 128 96H384C401.7 96 416 110.3 416 128V256C416 273.7 401.7 288 384 288H128zM400 400C382.3 400 368 385.7 368 368S382.3 336 400 336 432 350.3 432 368 417.7 400 400 400z'
      }
    ]
  }
})
